import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CallerLookupResult {
  customer: {
    id: string;
    customer_name: string;
    primary_phone: string | null;
    jobs_count: number;
    last_job: { id: string; job_number: string | null; status: string | null; job_date: string | null } | null;
  } | null;
  lead: {
    id: string;
    lead_number: string | null;
    customer_name: string | null;
    status: string | null;
    assigned_csr_id: string | null;
    assigned_csr_name: string | null;
  } | null;
}

// Looks up an incoming caller's phone number against customers and leads
// (RLS-scoped to the current user's company via the lookup_caller RPC).
export function useCallerLookup(phone: string | null | undefined) {
  const digits = (phone ?? '').replace(/\D/g, '').slice(-10);

  return useQuery({
    queryKey: ['caller-lookup', digits],
    queryFn: async (): Promise<CallerLookupResult> => {
      const { data, error } = await supabase.rpc('lookup_caller', { p_phone: digits });
      if (error) throw error;
      return (data ?? { customer: null, lead: null }) as unknown as CallerLookupResult;
    },
    enabled: digits.length >= 6,
    staleTime: 60_000,
  });
}
